import React from 'react';
import { ModalV2 } from '@dapp/multi-lib/ui/V2Modal';

interface ModalMenuProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  contentClassname?: string | undefined;
}

export const ModalMenu = (props: ModalMenuProps) => {
  const { open, children, onOpenChange, contentClassname } = props;

  return (
    <ModalV2.Root open={open} onOpenChange={onOpenChange}>
      <ModalV2.Trigger />
      <ModalV2.Content
        asChild
        variant='transparent'
        fullscreen
        className='absolute left-auto right-0 top-0 z-20 h-screen w-full translate-x-0 translate-y-0 pb-0 focus-visible:outline-none'
      >
        <ModalV2.Body
          variant='unstyled'
          className={`scrollbar-hide mx-0 my-0 h-screen max-h-full overflow-y-auto bg-light-textPrimary pb-10 focus-visible:outline-none ${contentClassname}`}
        >
          {children}
        </ModalV2.Body>
      </ModalV2.Content>
    </ModalV2.Root>
  );
};
